import { NoticeBanner, NoticeBannerPayload } from '~/api/types';
import { v2Api } from '../v2Api';

const tags = ['noticeBanner'] as const;

const noticeBannerApi = v2Api
  .enhanceEndpoints({
    addTagTypes: tags,
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getNoticeBanners: builder.query<NoticeBanner, object>({
        query: () => `boss/banner?is_active=true`,
        transformResponse: (response: { data: NoticeBanner[] }) => response.data[0],
        providesTags: tags,
      }),
      createNoticeBanner: builder.mutation<object, NoticeBannerPayload>({
        query: (body) => ({
          url: `boss/banner`,
          method: 'POST',
          body,
        }),
        invalidatesTags: tags,
      }),
      editNoticeBanner: builder.mutation<object, NoticeBannerPayload & { bannerId: number }>({
        query: ({ bannerId, ...body }) => ({
          url: `boss/banner/${bannerId}`,
          method: 'PATCH',
          body,
        }),
        invalidatesTags: tags,
      }),
      deleteNoticeBanner: builder.mutation<object, { bannerId: number }>({
        query: ({ bannerId }) => ({
          url: `boss/banner/${bannerId}`,
          method: 'DELETE',
        }),
        invalidatesTags: tags,
      }),
    }),
  });

export default noticeBannerApi;
